import {check} from "@/http/services/http-services-auth";
import {updateEditorTokens} from "@/helpers/datatable/datatable-editor-helper.js";

let timeout

export function setToken(result) {
    try {
        window.sessionStorage.accessToken = result.token
        window.sessionStorage.username = result.username
        window.sessionStorage.isAdmin = result.isAdmin
        window.sessionStorage.isSsoUser = result.isSsoUser

        if(timeout) {
            clearTimeout(timeout)
        }

        timeout = setTimeout(() => {
            check().then(result => {
                setToken(result)

                updateEditorTokens()
            })
        }, 6000 * 14)
    } catch (e) {
    }
}

export function deleteToken() {
    try {
        delete window.sessionStorage.accessToken
        delete window.sessionStorage.username
    } catch (e) {
    }
}

export function getToken() {
    try {
        return window.sessionStorage.accessToken
    } catch (e) {
        return undefined
    }
}

export function getUserName() {
    try {
        return window.sessionStorage.username
    } catch (e) {
        return ''
    }
}

export function isUserAdmin() {
    try {
        return window.sessionStorage.isAdmin
    } catch (e) {
        return ''
    }
}

export function isSsoUser() {
    try {
        return window.sessionStorage.isSsoUser
    } catch (e) {
        return ''
    }
}

export function isIpAddress() {
    try {
        return window.sessionStorage.isIpAddress
    } catch (e) {
        return ''
    }
}
